export function isLiffRoutePath(pathname = "") {
  return (
    pathname === "/liff" ||
    pathname.startsWith("/liff/") ||
    pathname === "/app/liff" ||
    pathname.startsWith("/app/liff/")
  );
}

